import { Validators } from '@angular/forms';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { diseasesValidator } from '@shared/validators/diseases-validator';

export const cancerscreenValidationSet: ValidationPair = {
  children: {
    cancerScreen: {
      children: {
        patientHistory: {
          children: {
            diseaseHistory: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
              },
              validators: [diseasesValidator()],
            },
            familyCancerHistory: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
              },
              validators: [diseasesValidator(true)],
            },
            knownFamilyMutations: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
              },
              validators: [diseasesValidator(true)],
            },
          },
        },
      },
    },
    shared: {
      children: {
        patientGender: {
          validators: [Validators.required],
        },
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
      },
    },
  },
};
